import React, { Dispatch, SetStateAction, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeSearchLocationAction } from "../../../store/projects/actions";

interface IDropDownSearchListProps {
  searchedData: any;
  setInputValue: Dispatch<SetStateAction<string>>;
  setShowDropDown: Dispatch<SetStateAction<boolean>>;
}

const DropdownSearchList = ({
  searchedData,
  setInputValue,
  setShowDropDown,
}: IDropDownSearchListProps) => {
  // const searchedData: any = [];
  const { suggestions } = searchedData ?? { suggestions: [] };
  const dispatch = useDispatch();
  const projectsDisplayed: any = [];

  const handleItemClick = (searchedData: any) => {
    if (projectsDisplayed === "Current") {
      // dispatch(searchCarbonProjectSelect(searchedData));
    } else if (projectsDisplayed === "Recommendations") {
      // dispatch(searchRecommendationSelect(searchedData));
    }
    dispatch(changeSearchLocationAction(searchedData));
    setInputValue(searchedData.name);
    setShowDropDown(false);
  };

  const dropDownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        dropDownRef.current &&
        !dropDownRef.current.contains(target as HTMLElement) &&
        target.tagName !== "INPUT" &&
        target.tagName !== "BUTTON"
      ) {
        setShowDropDown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [dropDownRef]);

  const groupedSuggestions: { [key: number]: any } = {};
  suggestions.forEach((suggestion: any) => {
    const { level } = suggestion;
    if (!groupedSuggestions[level]) {
      groupedSuggestions[level] = [];
    }
    groupedSuggestions[level].push(suggestion);
  });

  return (
    <div
      className="max-h-400 absolute left-1/2 top-14 z-20 w-full -translate-x-1/2 transform overflow-auto rounded-lg bg-white px-4 py-2 text-center shadow-md"
      ref={dropDownRef}
    >
      <ul>
        {suggestions.map((suggestion: any) => (
          <li
            className="flex cursor-pointer justify-between rounded-md p-1 px-2 hover:bg-blue-50"
            key={suggestion.id}
            onClick={() => handleItemClick(suggestion)}
          >
            <span>{suggestion.name}</span>
            <span className="opacity-70">{suggestion.type}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropdownSearchList;
